// extracted by mini-css-extract-plugin
export default {"debit":"BalanceDebit_debit__pbZvS","debitFooter":"BalanceDebit_debitFooter__SsLNX","tableLink":"BalanceDebit_tableLink__ddGHl"};